import React, { useRef, useState, useEffect } from 'react';
import { Bubble } from 'tea-component';
import useChangeSize from '@/pages/intelligence/hooks/useChangeSize';

export default function CoutrieTextHover(props: any) {
  const { coutriesList } = props;

  const size = useChangeSize();
  const divRef = useRef<any>(null);
  const [isEllipsis, setIsEllipsis] = useState(false);

  useEffect(() => {
    if (divRef && divRef?.current?.scrollHeight > divRef?.current?.clientHeight) {
      setIsEllipsis(true);
    } else {
      setIsEllipsis(false);
    }
  }, [size, JSON.stringify(coutriesList)]);

  const renderText = (_coutriesList: any[]) => {
    if (!Array.isArray(_coutriesList) || _coutriesList?.length === 0) {
      return <>-</>;
    }
    return _coutriesList?.map((item, idx) => (
      <span>{`${item?.name}${idx < _coutriesList.length - 1 ? ', ' : ' '}`}</span>
    ));
  };

  return (
    <div className="dbi-countrie-txt" ref={divRef}>
      <Bubble dark arrowPointAtCenter content={isEllipsis ? renderText(coutriesList) : null}>
        {renderText(coutriesList)}
      </Bubble>
    </div>
  );
}
